/* eslint-disable */
export default {
  createLog: 'ログを作成',
  creating: '作成中',
  save: '保存',
  saving: '保存中',
  saved: '保存済み',
  view: '表示',
  creatingFailed: '作成に失敗しました。',
  savingFailed: '保存に失敗しました。',
} as const;

// @key: @#@"createLog"@#@ @source: @#@"Create Log"@#@
// @key: @#@"creating"@#@ @source: @#@"Creating"@#@
// @key: @#@"save"@#@ @source: @#@"Save"@#@
// @key: @#@"saving"@#@ @source: @#@"Saving"@#@
// @key: @#@"saved"@#@ @source: @#@"Saved"@#@
// @key: @#@"view"@#@ @source: @#@"View"@#@
// @key: @#@"creatingFailed"@#@ @source: @#@"Creating failed."@#@
// @key: @#@"savingFailed"@#@ @source: @#@"Saving failed."@#@
